import WarningIcon from "@assets/icons/new/exclamation-mark-circle-fill_24px.svg?react";
import { Box, Stack, Typography } from "@mui/material";
import { CONSTRAINT_UNIT_LABEL } from "@src/constants/subscription-constants";
import { yellow } from "@flat-ui";
import {
  DEFAULT_BOLD_TEXT_FONT_WEIGHT,
  DEFAULT_INPUT_FONT_SIZE,
  DEFAULT_TEXT_FONT_WEIGHT,
} from "@styles/common-styles";
import { NumberUtils } from "@stellar/utils";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { hasExceededQuota } from "@hooks/subscription/use-usage-metrics";

interface Props {
  /** Subscription constraint */
  constraint: FaroCoreApiTypes.ConstraintQuota;

  /** Optional action or component rendered on the right side */
  actionComponent?: React.ReactNode;
}

/** Details of a subscription constraint */
export function SubscriptionConstraint({
  constraint,
  actionComponent,
}: Props): JSX.Element {
  const constraintNameDisplay = CONSTRAINT_UNIT_LABEL[constraint.identifier];
  const shouldShowWarning = hasExceededQuota(constraint);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <Typography
        sx={{
          gap: 1,
          display: "flex",
          alignItems: "center",
          fontSize: "20px",
          fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT,
          lineHeight: "30px",
        }}
      >
        {shouldShowWarning && (
          <WarningIcon color={yellow[500]} width={20} height={20} />
        )}
        {`${NumberUtils.formatNumberWithSpaces(constraint.current ?? 0)}`}
        <Box
          component="span"
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
            fontWeight: DEFAULT_TEXT_FONT_WEIGHT,
            lineHeight: "20px",
          }}
        >
          {`/ ${NumberUtils.formatNumberWithSpaces(
            constraint.limit
          )} ${constraintNameDisplay}`}
        </Box>
      </Typography>

      {actionComponent}
    </Stack>
  );
}
